import { useList, useDetail, useCreate, useUpdate, useDelete, useListInfinite } from "@inmagik/react-crud"
import { HistoricalInfo, Persona } from "../types"
import { API_URL } from "../constants"

export function usePersoneList(params: Record<string, string> = {}) {
  return useList<Persona>(`${API_URL}/persone`, {
    query: params,
  })
}

export function usePersona(id: number | undefined | string) {
  return useDetail<Persona>(`${API_URL}/persone`, id?.toString())
}

export function usePersonaCreate() {
  return useCreate<Persona>(`${API_URL}/persone`)
}

export function usePersonaUpdate() {
  return useUpdate<Persona>(`${API_URL}/persone`)
}

export function usePersonaDelete() {
  return useDelete<Persona>(`${API_URL}/persone`)
}

export function usePersonaHistory(id: number | string) {
  return useListInfinite<HistoricalInfo>(`${API_URL}/persone/${id}/history`)
}
